import { render } from "./CIS-Resource-PagedListing-PageInfo.vue?vue&type=template&id=0f938688&scoped=true"
import script from "./CIS-Resource-PagedListing-PageInfo.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-PagedListing-PageInfo.vue?vue&type=script&lang=js"

import "./CIS-Resource-PagedListing-PageInfo.vue?vue&type=style&index=0&id=0f938688&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f938688"]])

export default __exports__